/**
 * Placeholder brand for jopi while the theme is still unresolved.
 *
 * jopi falls back to Tokko Broker when no brand is passed, so until the page
 * payload tells us Tokko or Univen we hand it neutral greys instead (same
 * values as --colors-neutral-grey-* in designTokens.css).
 */
const JOPI_NEUTRAL_BRAND = {
  name: "neutral",
  colors: {
    primary: "#94A2AB",
    primaryHover: "#6A7981",
    primaryPressed: "#4D5A61",
    primaryAccent: "#EAEEF1",
    secondary: "#2E393F",
    secondaryHover: "#4D5A61",
    secondaryPressed: "#6A7981",
    petrokoPressed: "#4D5A61",
    petrokoHeader: "#2E393F",
    badgeOnBrand: "#94A2AB",
    badgeOnBrandText: "#FFFFFF",
  },
};

export default JOPI_NEUTRAL_BRAND;
